module.exports = __webpack_public_path__ + "static/dtssab-logo-021be7a50ecef3b9d894c60c0510670d.png";